import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'lib-spinner',
    styleUrls: ['./spinner.component.scss'],
    template: `
        <svg class="spinner" width="80px" height="80px" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="40" cy="40" r="30"></circle>
        </svg>
    `,
    imports: [CommonModule, TranslateModule]
})
export class SpinnerComponent {}
